import i18n from "i18next";
import { useEventId } from "./useEvent";
import { BASE_STORAGE_PATH } from "./usePersistedState";

const LOCALE_KEY_PREFIX = "camdeed-locale";

export const getLocaleStorageKey = (eventId: string) => `${LOCALE_KEY_PREFIX}-${eventId}`;

const isCamdeedHostname = () => {
  const href = window.location.href;
  return href.includes("localhost") || href.includes("127.0.0.1") || href.includes("camdeed.app") || href.includes("camdeed.com");
};

const brandDefault = (): AppLocale => (isCamdeedHostname() ? "en" : "lt");

const migrateFromAppData = (eventId: string): AppLocale | undefined => {
  try {
    const appDataKey = `${BASE_STORAGE_PATH}-${eventId}`;
    const raw = window.localStorage.getItem(appDataKey);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw);
    return parsed.locale as AppLocale | undefined;
  } catch {
    return undefined;
  }
};

export const getStoredLocale = (eventId: string): AppLocale => {
  try {
    const stored = window.localStorage.getItem(getLocaleStorageKey(eventId));
    if (stored) return stored as AppLocale;

    const migrated = migrateFromAppData(eventId);
    if (migrated) {
      window.localStorage.setItem(getLocaleStorageKey(eventId), migrated);
      return migrated;
    }
  } catch {
    // localStorage unavailable
  }

  return brandDefault();
};

export const useLocalePreference = () => {
  const eventId = useEventId();

  const setLocale = (locale: AppLocale) => {
    try {
      if (eventId) {
        window.localStorage.setItem(getLocaleStorageKey(eventId), locale);
      }
    } catch {
      // localStorage unavailable
    }
    i18n.changeLanguage(locale);
  };

  const getLocale = (): AppLocale => {
    if (!eventId) return brandDefault();
    return getStoredLocale(eventId);
  };

  return { getLocale, setLocale };
};
